import { render, staticRenderFns } from "./BlendBase.vue?vue&type=template&id=678e814e"
import script from "./BlendBase.vue?vue&type=script&lang=js"
export * from "./BlendBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports